import { useLocation } from 'react-router-dom'
import { getLang, withLang } from '@/lib/lang'
import { bookIntroEn } from '@/data/blocks.en'
// Yuichi 2026-09-16「他の関連サイト(the butler)などで紹介しているように、監修した本をビルドボードの下のセクションを追加して紹介してほしい。the butlerの書き方を参考にして。デザインはこっちのデザインでお洒落に紹介してね。最初のセクションである『クイーンズバトラーとは』の下のセクションに追加しよう」
// 事実は site-thebutler の bookDetail.ts / HeroBookBadge.tsx(正典)から。出版社表記は「Gakken」(八巻氏依頼)。
// Yuichi 2026-09-16「紹介ページは各サイトで作る」「トップページでは予約ページにダイレクトで飛ばさないで」: 導線は QB 内の紹介ページのみ
const BOOK_URL = '/book/butler-manners-and-culture/'
const COVER = '/img/book/gakken-butler-manners-cover.jpg'
const COVER_2X = '/img/book/gakken-butler-manners-cover@2x.jpg'
const COVER_TEXT = '『執事のマナーと教養図鑑』(Gakken)全日本執事協会 監修の書影'

export function BookIntro() {
  // EN ページでは bookIntroEn(英語文言)と /en 前置リンク。構造・CSS は共通
  const lang = getLang(useLocation().pathname)
  const en = lang === 'en'
  const url = withLang(BOOK_URL, lang)
  const meta: Array<[string, string]> = en ? bookIntroEn.meta : [['監修', '全日本執事協会'], ['協力', '執事喫茶Swallowtail'], ['出版', 'Gakken'], ['発売', '2026年9月17日'], ['仕様', '144ページ・1,870円(税込)']]
  return (
    <section className="book" aria-labelledby="book-heading">
      <div className="shell book-inner">
        <a className="book-cover" href={url} aria-label={en ? bookIntroEn.coverLabel : "『執事のマナーと教養図鑑』(Gakken・全日本執事協会 監修)の紹介ページを見る"}>
          <span className="book-cover-frame" aria-hidden="true" />
          <img src={COVER} srcSet={COVER + ' 1x, ' + COVER_2X + ' 2x'} width={408} height={600} alt={en ? bookIntroEn.coverAlt : COVER_TEXT} loading="eager" decoding="async" />
        </a>
        <div className="book-copy">
          <p className="book-eyebrow">Book — Supervised by the Japan Butler Association</p>
          <h2 id="book-heading" className="book-heading">{en ? bookIntroEn.heading : '全日本執事協会 監修の書籍'}</h2>
          <div className="book-orn" aria-hidden="true"><span /><i /><span /></div>
          <p className="book-title">{en ? bookIntroEn.title : '『執事のマナーと教養図鑑』'}</p>
          <p className="book-subtitle">{en ? bookIntroEn.subtitle : '英国紳士の美しい暮らしかた 50 Topics'}</p>
          <p className="book-lead">
            {en ? `${bookIntroEn.lead1} ${bookIntroEn.lead2}` : "執事の装いと所作、給仕とエスコートの作法、英国紳士の教養を、50 の話題でたどる一冊でございます。 Queen's Butler を運営する一般社団法人 全日本執事協会が監修を務めました。館で執事がまとう装いと、お嬢様にお仕えする所作は、この一冊に記された作法に沿っております。"}
          </p>
          <dl className="book-meta">
            {meta.map(([dt, dd]) => <div key={dt}><dt>{dt}</dt><dd>{dd}</dd></div>)}
          </dl>
          {/* Yuichi 2026-09-16「詳しく見るボタン…the butlerのをそのまま使うな。デザインはすべてこっちのHPにあわせろ」: QB 共通の金の罫線リンク(.link-more)に */}
          <div className="book-actions">
            <a className="link-more book-more" href={url}>{en ? bookIntroEn.more : 'この一冊のご紹介へ'}</a>
          </div>
        </div>
      </div>
    </section>
  )
}
